import { theme } from "@lvt/material";
import { makeStyles, createStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles(() =>
    createStyles({
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            height: "fit-content",
        },
        icon: {
            "&:hover": {
                color: "#D3D3D3",
                cursor: "pointer",
            },
        },
        content: {},
        selection: {
            color: "rgba(0, 0, 0, 0.54)",
            // color: theme.palette.warning.main,
        },
        modalFooter: {
            display: "flex",
            justifyContent: "flex-start",
        },
        cameraRequestStatus: {
            display: "flex",
            alignItems: "center",
            height: "100%",
        },
        loading: {
            color: theme.palette.info.main,
        },
        success: {
            color: theme.palette.success.main,
        },
        failed: {
            color: theme.palette.error.main,
        },
    }),
);
